import { render } from "./SectionFive.vue?vue&type=template&id=0a1664e7&scoped=true"
import script from "./SectionFive.vue?vue&type=script&lang=js"
export * from "./SectionFive.vue?vue&type=script&lang=js"

import "./SectionFive.vue?vue&type=style&index=0&id=0a1664e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1664e7"]])

export default __exports__